import { stringKeyToSentenceCase } from "../../../../../../../../utils";
import { getStageStatus } from "../../../../../../../../utils/workflow/getStageStatus";
import { normalizeStage } from "../../../../../../../../utils/workflow/normalizeStage";

export const COMPLETE_STATUS = "Complete";
export const IN_PROGRESS_STATUS = "In progress";
type DealDatesRecordLike = Record<string, Record<string, unknown> | null>;
const toStageLabel = (value: string): string => stringKeyToSentenceCase(value);

export interface NextStageAfterCompletion {
  nextStageKey: string | undefined;
  nextStageLabel: string | undefined;
  nextIncompleteStageKey: string | undefined;
  nextIncompleteStageLabel: string | undefined;
}

export const setStageStatus = (stage: Record<string, unknown> | null, status: string): Record<string, unknown> => {
  const nextStage = { ...(stage ?? {}) };

  if ("status" in nextStage && !("Status" in nextStage)) {
    nextStage.status = status;
    return nextStage;
  }

  nextStage.Status = status;
  return nextStage;
};

export const isCompleteStage = (stage: Record<string, unknown> | null | undefined): boolean =>
  normalizeStage(getStageStatus(stage)).includes("complete");

export const getNextStageAfterCompletion = (
  stageKeys: string[],
  currentStageIndex: number,
  dealDates: DealDatesRecordLike
): NextStageAfterCompletion => {
  const subsequentStageKeys = stageKeys.slice(currentStageIndex + 1);
  const nextStageKey = subsequentStageKeys[0];
  const nextIncompleteStageKey = subsequentStageKeys.find((stageKey) => !isCompleteStage(dealDates[stageKey]));

  return {
    nextStageKey,
    nextStageLabel: nextStageKey ? toStageLabel(nextStageKey) : undefined,
    nextIncompleteStageKey,
    nextIncompleteStageLabel: nextIncompleteStageKey ? toStageLabel(nextIncompleteStageKey) : undefined,
  };
};
